'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = require('./common');

exports.default = function (prop) {
  return (0, _common.withParams)({ type: 'requiredUnless', prop: prop }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/requiredUnless.js
// module id = 6+Xr
// module chunks = 64